import { useState, useRef, useContext, useEffect, use } from "react";
import { useNavigate } from "react-router-dom";

import { ReactSession } from "react-client-session";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import FormContext from "../../context/FormContext";
import "./Form.css";
import { getSuccessToast, getErrorToast } from "../../toast";

const Form = () => {
  const navigate = useNavigate();

  const axiosPrivate = useAxiosPrivate();
  const [poNo, setPoNo] = useState("");
  const [partyName, setPartyName] = useState("");
  const [partyList, setPartyList] = useState([]);
  const [partyId, setPartyId] = useState();
  const partyNameRef = useRef("");
  const partyCodeRef = useRef();
  const cityRef = useRef("");
  const [refNo, setRefNo] = useState("None");
  const [refdate, setRefdate] = useState("None");
  const [transporterName, setTransporterName] = useState("None");
  const [lrNo, setLrNo] = useState("None");
  const [lrdate, setlrDate] = useState("None");
  // const [goodsType, setGoodsType] = useState("Expiry");
  const [caseNo, setCaseNo] = useState("None");
  const [receiveddate, setReceivedDate] = useState("");
  const [remark, setRemark] = useState(null);
  const [disabled, setDisabled] = useState(false);

  const { setIsFormOpen } = useContext(FormContext);

  const prev = (e) => {
    e.preventDefault();
    setIsFormOpen(false);
    navigate("/operator");
    return;
  };

  window.addEventListener("popstate", prev);

  useEffect(() => {
    return () => {
      window.removeEventListener("popstate", prev);
    };
  }, []);

  const displayDetailsHandler = (e) => {
    let currentValue;
    setPartyName(e.target.value);
    if (["", undefined, null, " "].includes(e.target.value)) {
      partyCodeRef.current.value = "";
      cityRef.current.value = "";
      setPartyId("");
    }
    axiosPrivate
      .get(`/data_entry/partymaster_searchbar/?search=${e.target.value}`)
      .then((res) => {
        setPartyList(res.data.results);
      });
    const selectedOption = Array.from(e.target.list.options).find(
      (option) => option.value === e.target.value
    );
    if (selectedOption) {
      currentValue = JSON.parse(selectedOption.getAttribute("data-party"));
      setPartyName(currentValue.name);
      partyCodeRef.current.value = currentValue.customer;
      cityRef.current.value = currentValue.city;
      setPartyId(currentValue.party_master_id);
    }
  };

  const submitHandler = (e) => {
    e.preventDefault();

    if (!partyId) {
      getErrorToast("Please select party name from the list", 2000);
    } else if (cityRef.current.value.length > 2) {
      const boxData = {
        po_number: poNo,
        ref_number: refNo,
        ref_date: refdate,
        lr_number: lrNo,
        lr_date: lrdate,
        received_date: receiveddate,
        // open_date: opendate,
        case_number: parseInt(caseNo),
        transporter_name: transporterName,
        // goods_type: goodsType,
        serial_number: "ccx",
        created_by: 1,
        updated_by: 1,
        party_master: partyId,
        remark: remark,
      };

      setDisabled(true);
      axiosPrivate
        .post("/data_entry/form_entry/", boxData)
        .then((res) => {
          let boxId = res.data.stockists_master_id;
          ReactSession.set("box_id", boxId);
          setPartyId(null);

          getSuccessToast("Box added successfully", 2000);
          navigate("/upload");
          // setTimeout(() => {
          //   navigate("/operator");
          // });
        })
        .catch((err) => console.error(err))
        .finally(() => {
          setDisabled(false);
        });
    } else {
      getErrorToast("Add all Fields", 1000);
      setDisabled(false);
    }
  };


  return (
    <form onSubmit={submitHandler} className="home-form">
      <section className="c1 home-form-main-header">
        <h3>New Claim</h3>
      </section>

      <section className="home-form-section c2">
        <label htmlFor="po-no" className="home-form-header">
          S. No:
        </label>
        <input
          required={true}
          onChange={(e) => setPoNo(e.target.value)}
          className="home-form-input"
          type="text"
          id="po-no"
        />
      </section>

      <section className="home-form-section c3">
        <label htmlFor="party-name" className="home-form-header">
          PARTY NAME:
        </label>
        <input
          required={true}
          list="party-name"
          onChange={displayDetailsHandler}
          onFocus={displayDetailsHandler}
          className="home-form-input home-form-input-lg"
          value={partyName}
          ref={partyNameRef}
        />
        <datalist id="party-name">
          {partyList &&
            partyList.map((party) => (
              <option
                key={party.party_master_id}
                data-party={JSON.stringify(party)}
                value={`${party.customer} | ${party.name}`}
              >
                {" "}
                {party.customer} | {party.name} | {party.city}
              </option>
            ))}
        </datalist>
      </section>

      <section className="home-form-section c4">
        <label htmlFor="party-code" className="home-form-header">
          PARTY CODE:
        </label>
        <input
          required={true}
          ref={partyCodeRef}
          disabled={true}
          className="disabled home-form-input"
          type="text"
          id="party-code"
        />
      </section>

      <section className="home-form-section c5">
        <label className="home-form-header" htmlFor="city">
          CITY:
        </label>

        <input
          ref={cityRef}
          disabled={true}
          className="disabled home-form-input"
          type="text"
          id="city"
        />
      </section>

      <section className="home-form-section c6">
        <label className="home-form-header" htmlFor="ref-no">
          Claim No:
        </label>
        <input
          required={true}
          onChange={(e) => setRefNo(e.target.value)}
          className="home-form-input home-form-input-lg"
          type="text"
          id="ref-no"
        />
      </section>
      <section className="home-form-section c10">
        <label className="home-form-header" htmlFor="received-date">
          Claim Date:
        </label>
        <input
          required={true}
          onChange={(e) => setRefdate(e.target.value)}
          className="home-form-input home-form-date-input-lg"
          type="date"
          id="received-date"
          min="1995-01-01"
          max={new Date().toISOString().split("T")[0]}
        />
      </section>
      <section className="home-form-section c10">
        <label className="home-form-header" htmlFor="received-date">
          Received Date:
        </label>
        <input
          required={true}
          onChange={(e) => setReceivedDate(e.target.value)}
          className="home-form-input home-form-date-input-lg"
          type="date"
          id="received-date"
          min="1995-01-01"
          max={new Date().toISOString().split("T")[0]}
        />
      </section>

      <section className="home-form-section c8">
        <label className="home-form-header" htmlFor="lr-no">
          LR No:
        </label>
        <input
          required={true}
          onChange={(e) => setLrNo(e.target.value)}
          className="home-form-input"
          type="text"
          id="lr-no"
        />
      </section>

      <section className="home-form-section c9">
        <label className="home-form-header" htmlFor="lr-date">
          LR Date:
        </label>
        <input
          required={true}
          onChange={(e) => setlrDate(e.target.value)}
          className="home-form-input home-form-date-input-lg"
          type="date"
          name=""
          id="lr-date"
          min="1995-01-01"
          max={
            receiveddate === ""
              ? new Date().toISOString().split("T")[0]
              : receiveddate
          }
        />
      </section>

      <section className="home-form-section c12">
        {" "}
        <label className="home-form-header" htmlFor="case-no">
          No of Cases:
        </label>
        <input
          required={true}
          onChange={(e) => setCaseNo(e.target.value)}
          className="home-form-input"
          type="number"
          min={0}
          max={100}
          id="case-no"
        />
      </section>

      <section className="home-form-section c13">
        {" "}
        <label className="home-form-header" htmlFor="transporter-name">
          Transporter Name:
        </label>
        <input
          required={true}
          onChange={(e) => setTransporterName(e.target.value)}
          className="home-form-input home-form-input-lg"
          type="text"
          name=""
          id="transporter-name"
        />
      </section>

      <section className="home-form-section c12">
        {" "}
        <label className="home-form-header" htmlFor="transporter-name">
          Remark:
        </label>
        <input
          required={false}
          onChange={(e) => setRemark(e.target.value)}
          className="home-form-input home-form-input-lg"
          type="text"
          name=""
          id="transporter-name"
        />
      </section>

      <section className="home-form-submit-button-section c15">
        <button disabled={disabled} className="home-form-submit-button">
          Add new claim
        </button>
      </section>
    </form>
  );
};

export default Form;
